<template>
	<div class="row" v-if="$route.name == 'ferments.what-if'">
		<div class="col-md-4">
			<a v-link="{name: 'ferments.index', params: { fermenterId: fermenter.id, fermentId: ferment.id }}" class="btn btn-primary"><i class="fa fa-arrow-left"></i> Return To Ferment</a>
		</div>
		<div class="col-md-8">
			<div class="pull-right">
				<button class="btn btn-primary btn-sm" :disabled="simulatorRunning" @click.prevent="$dispatch('reloadGraph', true)">Run Simulation</button>

				<div class="btn-group">
					<button type="button" class="btn btn-block btn-sm btn-info dropdown-toggle" :disabled="simulatorRunning" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<i class="fa fa-download"></i> Download <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li>
							<a href="#" @click.prevent="download('excel')">
								<i class="fa fa-file-excel-o"></i> Download Excel File
							</a>
						</li>
						<li>
							<a href="#" @click.prevent="download('pdf')">
								<i class="fa fa-file-pdf-o"></i> Download PDF File
							</a>
						</li>
						<li>
							<a href="#" @click.prevent="download('jpg')">
								<i class="fa fa-file-image-o"></i> Download JPG File
							</a>
						</li>
					</ul>
				</div>
				<button @click.prevent="$dispatch('resetChanges')" class="btn btn-danger" :disabled="simulatorRunning"><i class="fa fa-repeat"></i> Reset</button>
			</div>
		</div>

		<form method="post" id="download-ferment">
			<input type="hidden" name="graph">
			<input type="hidden" name="ferment">
		</form>
	</div>
</template>

<script>

	import { fermenter, ferment, graphBase64, simulatorRunning } from 'vx/getters'
	import Http from 'utils/http'

	export default {
		vuex: {
			getters: {
				ferment,
				fermenter,
				graphBase64,
				simulatorRunning
			}
		},

		data() {
			return {};
		},

		ready() {

		},

		methods: {
			download(format) {
				let path = Http.buildPath(`ferments/${this.ferment.id}/export-${format}`);

				// Grab the snapshot of the canvas so we can send that along to the server.
				this.$dispatch('generateBase64');

				// Update the forms action and the hidden graph input with the generated
				// base64 of the graph then trigger the submission.
				$('#download-ferment')
					.find('input[name=graph]').val(this.graphBase64)
					.next().val(JSON.stringify({
							duration: this.ferment.duration,
							climate: this.ferment.climate,
							style: this.ferment.style,
							volume: this.ferment.volume,
							initial_cell_mass: this.ferment.initial_cell_mass,
							total_water_added: this.ferment.total_water_added,
							dailyData: this.ferment.dailyData
						}))
					.parent().attr('action', path).submit();
			},
		}
	};
</script>



// WEBPACK FOOTER //
// what-if.vue?12b57198